import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/Error404.png'


const _hoisted_1 = { class: "flexContainer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "errorMsg" }, "Ooooops! Page not found", -1)

import { useTitle } from '@vueuse/core';
import VButton from '@/components/VButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Error404',
  setup(__props) {

function goBack() {
    window.history.back();
}

useTitle("404 | Reply200")


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(VButton, {
      primary: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("Back")
      ]),
      _: 1
    })
  ]))
}
}

})